import http from "./http";

/* ================================
   CREATE MATCH
================================ */
export const createMatch = async (formData) => {
  const res = await http.post("create_match", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

/* ================================
   GET ALL MATCHES
================================ */
export const getMatches = async () => {
  const res = await http.get("create_match");
  return res.data;
};

/* ================================
   GET SINGLE MATCH
================================ */
export const getMatchById = async (id) => {
  const res = await http.get("create_match");
  return res.data?.data?.find((m) => String(m.id) === String(id));
};

/* ================================
   UPDATE MATCH
================================ */
export const updateMatch = async (id, formData) => {
  formData.append("action", "edit");
  formData.append("id", id);

  const res = await http.post("create_match", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
};

/* ================================
   DELETE MATCH
================================ */
export const deleteMatch = async (id) => {
  const res = await http.delete("create_match", {
    data: { id },
  });
  return res.data;
};

/* ================================
   ✅ GET MATCH RESULT (ADMIN)
================================ */
export const getMatchResults = async (match_id) => {
  const res = await http.get("match/a_result_get", {
    params: { match_id },
  });
  return res.data;
};

/* ================================
   ✅ SETTLE MATCH (ADMIN)
================================ */
/* ================================
   ✅ SETTLE MATCH (ADMIN) - FIXED
================================ */
export const settleMatch = async (payload) => {
  const res = await http.post(
    "match/settle",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return res.data;
};